<template>
	<div class="flex flex-col justify-start">
		<div class="min-w-full flex-grow pb-36 overflow-x-auto bg-gray-100">
			<!-- overflow-hidden -->

			<div
				class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
			>
				<table class="min-w-full divide-y divide-gray-200 bg-white">
					<thead class="bg-gray-50">
						<tr>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
								width="20%"
							>
								{{ __("Goods/Harvest") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
								width="20%"
							>
								{{ __("Fulfilment Date") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Quantity") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex justify-start"
							>
								<div class="w-2/3 inline-block">
									{{ __("Price") }}
								</div>
								<div class="w-1/3 inline-block pl-2">
									{{ __("Price") }} / {{ __("Basis") }}
								</div>
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
								width="20%"
							>
								{{ __("Location") }}
							</th>
							<th
								scope="col"
								class="pl-2 pr-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
							></th>
						</tr>
					</thead>
					<tbody class="divide-y divide-gray-200">
						<auction-edit-bid
							v-for="(offer, idx) in offers"
							:key="'OFFER_' + idx"
							:offer="offer"
							:bid="offer.auctionBids[0]"
							:idx="idx"
							:active-futures="activeFutures"
						/>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		auction: {
			type: Object,
			required: true,
		},
		offers: {
			type: Array,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {},
	computed: {},
};
</script>
